import axiosInstance from "utils/request";
import {
  ObjectTypeMergePreviewSchema,
  ObjectTypeMergeExecuteResultSchema,
  type ObjectTypeMergePreview,
  type ObjectTypeMergeExecuteResult,
} from "./schemas";

export async function previewObjectTypeMerge(
  sourceTypeId: number,
  targetTypeId: number,
): Promise<ObjectTypeMergePreview> {
  const { data } = await axiosInstance.get("/object_type_merge/preview", {
    params: { source_type_id: sourceTypeId, target_type_id: targetTypeId },
  });
  return ObjectTypeMergePreviewSchema.parse(data);
}

export async function executeObjectTypeMerge(
  sourceTypeId: number,
  targetTypeId: number,
): Promise<ObjectTypeMergeExecuteResult> {
  const { data } = await axiosInstance.post("/object_type_merge/execute", {
    source_type_id: sourceTypeId,
    target_type_id: targetTypeId,
  });
  return ObjectTypeMergeExecuteResultSchema.parse(data);
}
